
import { getStorage } from '~/services/storage';

export default {
    name: 'JoinPrompt',
    data() {
        return {
            loginConverted: getStorage('loginConverted'),
        };
    },
};
